module.exports = __webpack_public_path__ + "static/media/icon-info.1c478648.svg";